/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Password extends BaseField {

    protected opts: PasswordOptions;

    constructor (element: string | JQuery, opts: PasswordOptions = {}) {
        super(element, opts);

        let self = this;

        this.element.find('button').on('click', () => {
            let input = this.getInput();
            let button = this.element.find('button');

            switch (input.attr('type')) {
                case 'password':
                    input.attr('type', 'text');
                    button.html('<i class="fa fa-eye-slash"></i> Hide');
                    break;
                case 'text':
                    input.attr('type', 'password');
                    button.html('<i class="fa fa-eye"></i> Show');
                    break;
            }
        });
    }

    public getValue() {
        return this.getInput().val();
    }

    public setValue(newValue: string) {
        this.getInput().val(newValue);
    }

    private getInput() {
        return this.element.find('input');
    }
}

interface PasswordOptions extends FieldOptions {
}

}
